import {
  fetchDeleteItemFailure,
  fetchDeleteItemSuccess,
} from "./reducer";
import { toast } from "react-toastify";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { DELETE_ITEM } from "../../constants/constants";
import { getItems } from "../GetItem/thunk";

export const deleteItem =
  (
    id,
    setLoading,
    pageSize,
    pageIndex,
    searchText = ""
  ) =>
  async (dispatch) => {
    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        DELETE_ITEM(id),
        "DELETE"
      );

      if (response?.error) {
        dispatch(fetchDeleteItemFailure(response.error.message));

        toast.error(response.error.message);
      } else {
        dispatch(fetchDeleteItemSuccess(response));
        toast.success("Product Deleted Successfully");
        // dispatch(
        //   getItems(
        //     pageSize,
        //     pageIndex + 1,
        //     searchText
        //   )
        // );
      }
    } catch (error) {
      dispatch(
        fetchDeleteItemFailure(
          error?.message || "Something went wrong"
        )
      );
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };